<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">

        <!--<div class="col-md-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo" class="user-image-circle-65px img7">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">GST:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">CIN:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-5 padding-right-5px border-color-blue" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>
        </div>-->

      </div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center padding-top-5px">
            <label class="font-familyhead">Department of {{DepartmentName}}</label>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">ID:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.FormattedCode}}</label>
                </div>
              </div>

              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Lab Order No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{LabOrderCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Lab Order Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{EffectiveOrderDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>

            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Age / Gender:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Telephone:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Telephone1}}</label>
                </div>
              </div>

              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FacilityName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Specimen:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{SpecimenName}}</label>
                </div>
              </div>

            </div>
          </div>

        </div>
        <!--<div class="row " *ngIf="LabOrderResultsData">
    <div class="col-print-12 text-align-center padding-top-5px">
      <label class="font-familyhead">{{LabOrderResultsData.TestName}}</label>
    </div>
  </div>-->
        <div class="col-print-12">
          <div class="row">
            <div class="col-print-12 text-align-center padding-top-5px">
              <label class="font-familyhead border-bot-1px">{{TestName}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px" *ngIf="LabOrderResultsData">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Specimen Collection Date/Time:</label>
            </div>
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">{{LabOrderResultsData.SpecimenCollectionDate | date:'dd-MMM-yyyy'}}/{{LabOrderResultsData.SpecimenCollectionTime | date: 'hh:mm a'}}</label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-10px margin-right-0px" *ngIf="CurrentLabOrderTestResultsController">
            <div class="row col-print-12 margin-left-0px margin-right-0px">
              <!-- header -->
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">
                  Observation
                </label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">
                  Result
                </label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">
                  Biological Normal Range
                </label>
              </div>

            </div>
            <div class="row col-print-12 margin-left-0px margin-right-0px" *ngFor="let l  of ExaminationTypes">
              <div class="row col-print-12 margin-left-0px margin-right-0px background-lightblue margin-bottom-3px">
                <label class="margin-bottom-0px font-family font-weight-bold color-Assign">
                  {{l}}
                </label>
              </div>
              <div class="row col-print-12 margin-left-0px margin-right-0px margin-bottom-3px"
                   *ngFor="let n of GetDetailsByExaminationType(TestName, l)">

                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family">
                    {{n.ObservationName}}
                  </label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family">
                    {{n.ObservationValue}} / {{n.UOM}}
                  </label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family">
                    {{n.ReferenceRange}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="col-print-12">
    <div class="row margin-right-0px margin-left-0px">
      <div class="col-print-12">
        <div class="table-component margin-bottom-0px border4">
          <div class="table-responsive">
            <table class="table table-striped margin-left-zero">
              <thead>
                <tr>

                  <th class="font-weight-bold background-primary padding-top-2px padding-bottom-2px font-family text-align-center width-35px">
                    #
                  </th>

                  <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                    Test Name
                  </th>
                  <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                    Test Method
                  </th>
                  <th class="font-weight-bold background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                    Result
                  </th>
                  <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">

                  </th>
                  <th class="width-150px font-weight-bold background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                    Biological Reference Intervals
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let n of GetDetails(TestName) ; let RowIndex = index">
                  <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{RowIndex+1}}</td>
                  <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{n.ObservationName}}</td>
                  <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{n.ObservationMethod}}</td>
                  <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{n.ObservationValue}}</td>
                  <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{n.UOM}}</td>
                  <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{n.ReferenceRange}}</td>

                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>

  </div>-->
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
    </div>
  </div>-->

        <div class="col-print-12" *ngIf="Remarks != 'null'">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Comments</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12" *ngIf="Remarks != 'null'">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-12">
              <label class="margin-bottom-0px font-family">{{Remarks}}</label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12 margin-top-30px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family">{{FirstSigningName}}</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">{{SecondSigningName}}</label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family"></label>
      </div>
    </div>
  </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-8">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family text-align-center">Lab Incharge</label>
                </div>

              </div>
            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family text-align-center">Report Verified By</label>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
      </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
